import { ComponentProps } from "react";

const ImportIcon = (props: ComponentProps<"svg">) => {
  return (
    <svg width="22" height="24" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_2751_16800)">
        <path
          d="M14.915 0.923828V5.5878C14.915 5.89704 15.0379 6.19361 15.2566 6.41228C15.4752 6.63094 15.7718 6.75379 16.081 6.75379H20.745"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.42083 12.5837V3.25581C4.42083 2.63733 4.66652 2.04418 5.10385 1.60685C5.54118 1.16952 6.13433 0.923828 6.75281 0.923828H14.9148L20.7447 6.75379V19.5797C20.7447 20.1982 20.499 20.7913 20.0617 21.2287C19.6244 21.666 19.0312 21.9117 18.4127 21.9117H11.9998M0.922852 19.5797H9.08479M5.58682 16.0817L9.08479 19.5797L5.58682 23.0777"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2751_16800">
          <rect width="21.2308" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ImportIcon;
